const filterByEntity = (emails, entity) =>
  emails.filter(email => email.entity === entity)

export default filterByEntity
